import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["title", "isSelected", "onClick", "primaryMode", "to", "iconName", "badgeVariant", "showBadge"];
import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import { Badge, ListItem, ListItemIcon, Icon, makeStyles, Typography, RaiseColors, useTheme } from "client/componentLibrary";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      listItem: function listItem(_ref) {
        var isSelected = _ref.isSelected;
        return {
          paddingLeft: 20,
          paddingRight: 20,
          "&:hover": _defineProperty({
            backgroundColor: "transparent",
            "& p, span": {
              color: isSelected ? RaiseColors.destructive500 : RaiseColors.black
            }
          }, "& .".concat(listItemIconClasses.root), isSelected ? {
            fontWeight: "normal",
            color: RaiseColors.destructive500
          } : {
            fontWeight: 300,
            color: RaiseColors.black
          })
        };
      },
      listItemText: function listItemText(_ref2) {
        var isSelected = _ref2.isSelected,
          primaryMode = _ref2.primaryMode;
        return _defineProperty(_defineProperty({
          fontSize: "16px"
        }, theme.breakpoints.up("laptop"), {
          fontSize: primaryMode ? "14px" : "13px"
        }), "fontWeight", isSelected ? 600 : 400);
      },
      listItemIcon: {
        minWidth: 0,
        paddingRight: "8px",
        textAlign: "center",
        display: "grid",
        width: 24,
        height: 16
      },
      icon: function icon(_ref4) {
        var isSelected = _ref4.isSelected;
        return _defineProperty({
          overflow: "visible",
          color: isSelected ? RaiseColors.destructive500 : RaiseColors.gray300,
          fontWeight: isSelected ? "normal" : 300,
          fontSize: 16
        }, theme.breakpoints.up("laptop"), {
          fontSize: 14
        });
      },
      badgeRoot: {
        width: "100%",
        alignItems: "baseline"
      },
      badgeAnchor: _defineProperty({
        top: "10px",
        right: "8px"
      }, theme.breakpoints.up("laptop"), {
        fontSize: 4
      }),
      dot: {
        height: "8px",
        minWidth: "8px",
        backgroundColor: RaiseColors.shamrock
      }
    };
  });
};
var HorizontalListItem = function HorizontalListItem(_ref6) {
  var title = _ref6.title,
    isSelected = _ref6.isSelected,
    onClick = _ref6.onClick,
    _ref6$primaryMode = _ref6.primaryMode,
    primaryMode = _ref6$primaryMode === void 0 ? true : _ref6$primaryMode,
    _ref6$to = _ref6.to,
    to = _ref6$to === void 0 ? undefined : _ref6$to,
    iconName = _ref6.iconName,
    _ref6$badgeVariant = _ref6.badgeVariant,
    badgeVariant = _ref6$badgeVariant === void 0 ? "dot" : _ref6$badgeVariant,
    _ref6$showBadge = _ref6.showBadge,
    showBadge = _ref6$showBadge === void 0 ? false : _ref6$showBadge,
    props = _objectWithoutProperties(_ref6, _excluded);
  var classes = useStyles()({
    isSelected: isSelected,
    primaryMode: primaryMode
  });
  var content = /*#__PURE__*/_jsx(Badge, {
    "data-testid": "badge-container",
    invisible: !showBadge,
    variant: badgeVariant,
    classes: {
      root: classes.badgeRoot,
      anchorOriginTopRightRectangular: classes.badgeAnchor,
      dot: classes.dot
    },
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [iconName && /*#__PURE__*/_jsx(ListItemIcon, {
        "data-testid": "icon-list-container",
        className: classes.listItemIcon,
        children: /*#__PURE__*/_jsx(Icon, {
          className: classNames(classes.icon, iconName)
        })
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": "nav-title",
        color: isSelected ? RaiseColors.destructive500 : RaiseColors.gray300,
        weight: "regular",
        classes: {
          root: classes.listItemText
        },
        children: title
      })]
    })
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: to === undefined ? /*#__PURE__*/_jsx(ListItem, {
      className: classes.listItem,
      onClick: onClick,
      children: content
    }) : /*#__PURE__*/_jsx("li", {
      onClick: onClick,
      children: /*#__PURE__*/_jsx(ListItem, {
        "data-testid": "list-item-content",
        className: classes.listItem,
        component: Link,
        to: to,
        children: content
      })
    })
  });
};
export default HorizontalListItem;